﻿import { BrowserDetector } from "../../util/browser/BrowserDetector";

/**
 * Checks if the current browser is end-of-life and redirects to the unsupported page.
 * This should be called as early as possible in the app bootstrap, before any rendering occurs.
 * @returns true if the browser is EOL and a redirect was triggered, false otherwise.
 */
export function redirectIfEolBrowser(window: Window): boolean {
    if (BrowserDetector.isThisAnEOLBrowser()) {
        window.location.replace("/POW3/unsupported.html");
        return true;
    }
    return false;
}

